'use client';

import MarketingContent from './MarketingContent';

export default function Marketing() {
  return <MarketingContent />;
}
